import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";

const PageTitles = ({ title, authentication_state }) => {
  const authentication_ref = useRef(authentication_state);
  authentication_ref.current = authentication_state;
  return (
    <Helmet>
      <title>
        {title +
          " | " +
          authentication_ref?.current?.retailer_info?.response?.name}
      </title>
    </Helmet>
  );
};
PageTitles.propTypes = {
  authentication_state: PropTypes.object,
};
const mapStateToProps = ({ authentication }) => ({
  authentication_state: authentication,
});
export default connect(mapStateToProps)(PageTitles);
